import React from 'react';
import { FluentProvider } from '@fluentui/react-components';
import { useTheme } from '../contexts/ThemeContext';
import { rewordgenieLightTheme, rewordgenieDarkTheme } from '../theme/fluentTheme';

// Bridges the app's existing ThemeContext (single source of truth for light/dark)
// to Fluent's FluentProvider, so the existing ThemeToggle drives Fluent components too.
export default function FluentRoot({ children }) {
  const { isDark } = useTheme();

  return (
    <FluentProvider theme={isDark ? rewordgenieDarkTheme : rewordgenieLightTheme}>
      {children}
    </FluentProvider>
  );
}
